import { SolarScreenMap } from '~/machines/solar-funnel/screen-map';
import { ScreenMapCopy } from '~/machines/utils/types';
import { CreateAccountContext, CreateAccountCopy } from '~/screens/create-account';
import { CredentialsContext, CredentialsCopy } from '~/screens/credentials';
import { VnmTermsContext, VnmTermsCopy } from '~/screens/vnm-terms';
import { UTILITY_IDS } from '~/utils/constants';

const OregonLmiTier2UserDescription =
  "Create your Arcadia account and we'll match you with a community solar farm in your area. You'll save 40% on the solar credits applied to your power bill, guaranteed. (Savings quoted is for qualifying low-income households. For all others, the savings rate is 5%).";

// ucb-specific copy for the credentials screen
export const copy: ScreenMapCopy<SolarScreenMap> = {
  enrollment: {
    utilityConnect: (context: CredentialsContext): Partial<CredentialsCopy> => ({
      description: `We need your utility information to understand your energy usage and maximize your savings. We're not replacing ${context.utility.displayName}. Nothing changes about how you pay your bill. And don't worry, we use industry-standard encryption to keep your data safe and secure.`,
    }),
  },
  user: {
    user: (context: CreateAccountContext): Partial<CreateAccountCopy> => {
      if (isUserFromOregon(context)) return { description: OregonLmiTier2UserDescription };
      return {};
    },
    google: (context: CreateAccountContext): Partial<CreateAccountCopy> => {
      if (isUserFromOregon(context)) return { description: OregonLmiTier2UserDescription };
      return {};
    },
  },
  legal: {
    review: (context: VnmTermsContext): Partial<VnmTermsCopy> => {
      if (isUserFromOregon(context))
        return {
          savingsBenefit:
            'Save 40% on the solar credits applied to your power bill, guaranteed. (Savings quoted is for qualifying low-income households. For all others, the savings rate is 5%)',
        };
      return {};
    },
  },
};

function isUserFromOregon(context: CreateAccountContext | VnmTermsContext) {
  return (
    [UTILITY_IDS['Portland General Electric'], UTILITY_IDS['Pacific Power OR']] as number[]
  ).includes(context.utility.id);
}
